/*
 * Permission page
 */

import React from "react";
import { useState, useEffect, useRef } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Row,
  Button,
  Input,
  Select,
  DatePicker,
  Table,
  Space,
  Modal,
  Badge,
} from "antd";
import { Typography } from "antd";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import {
  FilterOutlined,
  ReloadOutlined,
  DownloadOutlined,
  EditOutlined,
  DeleteOutlined,
  SafetyOutlined,
  CloudUploadOutlined,
  CloseOutlined,
  SearchOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import "../Dashboard/index.css";
import "../EmployeeManagement/index.css";
import SimpleReactValidator from "simple-react-validator";
import BreadcrumbComponent from "../../components/BreadCrumb";
import { toast, ToastContainer } from "react-toastify";
import TextArea from "antd/es/input/TextArea";
import { isEmpty } from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import * as permissionAction from "../../store/LeaveAndPermission/actions";
import moment from "moment";
import api from "../../helpers";
import "./permission.css";
import dayjs from "dayjs";
import "../LeaveAndPermissions/LeaveDetails.css";

//bread crumb
const BCrumb = [{ to: "/", title: "Home" }, { title: "Permission" }];

const Permission = () => {
  //filter initial state
  const userType = localStorage.getItem("userType");
  const [searchLoading, setSearchLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [filterEmployee, setFilterEmployee] = useState([]);
  const [filterEmployeeClear, setFilterEmployeeClear] = useState(false);

  const simpleValidator = useRef(new SimpleReactValidator());
  const simpleApproveValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = React.useState();
  const [employeeCodeList, setEmployeeCodeList] = useState([]);
  const [employeeCodeClear, setEmployeeCodeClear] = useState(false);
  const [permissionId, setPermissionId] = useState();
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [employeePayloadId, setEmployeePayloadId] = useState("");
  const [approvalModalStatus, setApprovalModalStatus] = useState([]);
  const [approvalModalOpen, setApprovalModalOpen] = useState(false);

  const [isConfirmVisible, setIsConfirmVisible] = useState(false);

  // getting lat and long
  const [location, setLocation] = useState({ lat: null, lon: null });

  // delete modal
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const specificDispatch = useDispatch();
  const dispatch = useDispatch();

  //searchInput
  const [searchInput, setSearchInput] = useState("");
  const [searchValue, setSearchValue] = useState({
    limit: 10,
    page: 1,
    status: "BOTH",
  });

  //dropdown state from reducer
  const dropdownUpdate = useSelector((specificstate) => specificstate.Leave);
  const { dropDownList = {}, permissionList = {} } = dropdownUpdate;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(permissionList?.total); // get this from your API response

  useEffect(() => {
    if (permissionList) {
      setTotalCount(permissionList?.total); // total is total count of records in the backend
    }
  }, [permissionList]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    specificDispatch(
      permissionAction.loadPermission({
        limit: 10,
        page: 1,
        status: "BOTH",
      })
    );
    specificDispatch(permissionAction.loadLeaveDropdown());
  }, [specificDispatch]);

  const handleDeleteModalCancel = () => {
    setDeleteModalOpen(false);
  };

  // appove modal
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const handleApproveModalCancel = () => {
    setApproveModalOpen(false);
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setLocation({
          lat: position.coords.latitude,
          lon: position.coords.longitude,
        });
      });
    }
  }, []);
  //filter initial data
  const [filterPermission, setFilterPermission] = useState({
    employeeCode: "",
    permissionFromDate: "",
    permissionToDate: "",
  });

  //modal initial data
  const [permission, setPermission] = useState({
    date: "",
    duration: "",
    fromTime: "",
    toTime: "",
    reason: "",
  });

  //modal dropdown initial state
  const [department, setDepartment] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [fileNames, setFileNames] = useState([]);

  //filter dropdown initial value
  const [departments, setDepartments] = useState([]);
  const [approvalStatus, setApprovalStatus] = useState([]);

  const [disabled, setDisabled] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);

  const [remarks, setRemarks] = useState("");

  const columnApproval = [
    { title: "S.No", dataIndex: "sno", width: 70 },
    { title: "Approved By", dataIndex: "approvedBy" },
    { title: "Approved Date", dataIndex: "approvedDate" },
    { title: "Remarks", dataIndex: "remarks" },
  ];

  const selectedRecord =
    permissionList?.data?.find((item) => item._id === permissionId) || null;

  const tableApprovalData = selectedRecord
    ? [
        {
          _id: selectedRecord._id,
          sno: 1,
          approvedBy: selectedRecord.approvedByUserName || "--",
          approvedDate: selectedRecord.approvedOn
            ? moment(selectedRecord.approvedOn).format("DD/MM/YYYY")
            : "--",
          remarks: selectedRecord.remarks || "--",
        },
      ]
    : [];

  //delete
  const handleDelete = () => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);
    const payload = {
      id: [permissionId],
      status:3
    };
    api
      .post(`/auth/deletepermission`, payload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          specificDispatch(permissionAction.loadPermission(searchValue));
          // dispatch(leaveAction.loadLeaveDetails(searchValue));
          toast.success("Leave details deleted successfully");
        } else {
          toast.warning(response?.data?.msg || "");
        }
        setDeleteModalOpen(false);
        return response.data;
      })
      .catch((err) => {
        setDeleteModalOpen(false);
        const errorMsg =
        err?.response?.data?.error||err?.response?.data?.message ||
          "An error occurred while deleting the leave details";
        toast.error(errorMsg);
        return Promise.reject(err);
      });
  };

  //update approval
  const handleApproveUpdate = () => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);
    if (simpleApproveValidator.current.allValid()) {
      const payload = {
        PermissionStatus: approvalModalStatus.value,
        remarks: remarks,
      };
      api
        .post(`/auth/permissionapproval/${permissionId}`, payload)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            specificDispatch(permissionAction.loadPermission(searchValue));
            // dispatch(leaveAction.loadLeaveDetails(searchValue));
            toast.success("Leave details approved successfully");
          } else {
            toast.warning(response?.data?.msg || "");
          }
          setApproveModalOpen(false);
          return response.data;
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.message ||
            "An error occurred while approving the leave details";
          toast.error(errorMsg);
          return Promise.reject(err);
        });
    } else {
      simpleApproveValidator.current.showMessages(); // SHOW all error messages
      forceUpdate(1);
    }
  };

  //modal input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPermission((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleApprovalChange = (e) => {
    const { name, value } = e.target;
    if (name === "remarks") {
      setRemarks(value);
    }
  };

  //filter date handler
  const handleFilterDateChange = (name, value) => {
    setFilterPermission((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //modal date handler
  const handleDateChange = (name, value) => {
    setPermission((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const isToday =
    permission.date && dayjs(permission.date).isSame(dayjs(), "day");
  const isBefore9AM = dayjs().isBefore(dayjs().hour(9).minute(0)); // current time check
  const isTimeInputDisabled = isToday && !isBefore9AM;
  //modal time handler
  const handleTimeChange = (name, value) => {
    setPermission((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: value,
      };
      if (updatedData.fromTime && updatedData.toTime) {
        const durationInMinutes = updatedData.toTime.diff(
          updatedData.fromTime,
          "minutes"
        );

        if (durationInMinutes >= 0) {
          const hours = Math.floor(durationInMinutes / 60);
          const minutes = durationInMinutes % 60;
          updatedData.duration = `${hours} h ${minutes} m`;
        } else {
          updatedData.duration = "Invalid time range";
        }
      }
      return updatedData;
    });
  };

  //filter reset functionality
  const onReset = () => {
    setSearchInput("");
    setSearchValue({
      limit: 10,
      page: 1,
      status: "BOTH",
    });
    setResetLoading(true);
    setTimeout(() => {
      setFilterPermission({
        employeeCode: "",
        permissionFromDate: "",
        permissionToDate: "",
      });
      setFilterEmployee([]);
      setFilterEmployeeClear(true);
      setTimeout(() => {
        setFilterEmployeeClear(false);
      }, 0);
      setDepartments([]);
      setApprovalStatus([]);

      setResetLoading(false);
    }, 1000);
    dispatch(
      permissionAction.loadPermission({
        limit: 10,
        page: 1,
        status: "BOTH",
      })
    );
    setIsEdit(false);
    setDisabled(false);
  };

  const handleEmployeeSelect = (selectedEmployee) => {
    // setEmployeeCodeList(selectedEmployee);

    if (selectedEmployee.departmentName) {
      setDepartment({
        label: selectedEmployee.departmentName,
        value: selectedEmployee._id,
      });
    }

    if (selectedEmployee.designationName) {
      setDesignation({
        label: selectedEmployee.designationName,
        value: selectedEmployee._id,
      });
    }
  };

  const fuseOptions = {
    keys: ["employeeCode", "label"],
  };

  const handleEmployeeCodeClear = () => {
    setEmployeeCodeList([]);
    clearModelData();

    setEmployeeCodeClear(true);
    setTimeout(() => {
      setEmployeeCodeClear(false);
    }, 0);
  };

  //filter functionality

  const handleFilter = (e) => {
    e.preventDefault();
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    let searchFilter = {};
    searchFilter.status = "BOTH";
    if (filterPermission.permissionFromDate)
      searchFilter.dateOfPermission =
        filterPermission.permissionFromDate.format("YYYY-MM-DD");
    if (filterPermission.permissionToDate)
      searchFilter.toDate =
        filterPermission.permissionToDate.format("YYYY-MM-DD");
    if (filterPermission.employeeCode)
      searchFilter.employeeCode = filterPermission.employeeCode;
    if (!isEmpty(filterEmployee))
      searchFilter.employeeCode = filterEmployee?.value;
    if (!isEmpty(departments)) searchFilter.departmentId = departments.value;
    if (!isEmpty(approvalStatus))
      searchFilter.PermissionStatus = approvalStatus.value;
    setSearchValue(searchFilter);
    //dispatch
    if (!isEmpty(searchFilter)) {
      dispatch(permissionAction.loadPermission(searchFilter));
    } else {
      dispatch(permissionAction.loadPermission({ status: "BOTH" }));
    }
  };

  const handleInitialSubmit = () => {
    if (simpleValidator.current.allValid()) {
      setIsConfirmVisible(true); // Open confirmation modal
    } else {
      simpleValidator.current.showMessages(); // Show validation messages
      forceUpdate(1);
    }
  };

  //submit functionality

  const handleSubmit = () => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false);
    }, 4000);

    const payload = {
      longitude: location.lon,
      latitude: location.lat,
      employeeId: employeePayloadId,
      dateOfPermission: permission.date.format("YYYY-MM-DD"),
      permissionHours: permission.duration,
      fromHours: permission.fromTime
        ? moment(permission.fromTime.toDate()).format("HH:mm")
        : "",
      toHours: permission.toTime
        ? moment(permission.toTime.toDate()).format("HH:mm")
        : "",
      status: 1,
      ...(permission.reason && { reason: permission.reason }),
      ...(!isEmpty(imagePreviews) && { attachment: imagePreviews[0].url }),
    };

    const endpoint = isEdit
      ? `/auth/updatepermission/${permissionId}`
      : "/auth/applypermission";

    api
      .post(endpoint, payload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(permissionAction.loadPermission(searchValue));
          toast.success(
            isEdit
              ? "Permission details updated successfully"
              : "Permission details added successfully"
          );
        } else {
          toast.warning(response?.data?.msg || "");
        }
        setIsModalVisible(false);
        setIsConfirmVisible(false);
      })
      .catch((err) => {
        setIsModalVisible(false);
        setIsConfirmVisible(false);
        const errorMsg =
          err?.response?.data?.message ||
          `An error occurred while ${
            isEdit ? "updating" : "adding"
          } the permission`;
        toast.error(errorMsg, { containerId: "toast-1" });
      });
  };
  //edit functionality

  const handleEdit = (item) => {
    setShowDropdown(false);
    const permission = item.editData;
    setPermission({
      employeeCode: permission.employeeCode || "",
      date: permission.dateOfPermission
        ? dayjs(permission.dateOfPermission)
        : null,
      fromTime: permission.fromHours
        ? dayjs(permission.fromHours, "HH:mm")
        : null,
      toTime: permission.toHours ? moment(permission.toHours, "HH:mm") : null,
      reason: permission.reason || "",
      duration: item.duration || "",
    });

    setDepartment({
      label: permission.employeeId?.departmentId?.departmentName || "--",
      value: permission.employeeId?.departmentId?._id || "",
    });

    setDesignation({
      label: permission.employeeId?.designationId?.designationName || "--",
      value: permission.employeeId?.designationId?._id || "",
    });
    const defaultLabel = `${permission.employeeCode} - ${permission.employeeName}`;
    setEmployeeCodeList(defaultLabel);
    setEmployeePayloadId(permission?.employeeId?._id);
    // setEmployeeCodeList(permission._id);
    setIsEdit(true);
    setIsModalVisible(true);

    if (permission.attachment) {
      setFileNames(permission.attachment);
      setImagePreviews([
        {
          url: permission.attachment,
          name: permission.attachment,
        },
      ]);
    } else {
      setImagePreviews([]);
    }
  };

  //download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = async () => {
    setDownloadLoader(true);
    let searchFilter = {};

    if (filterPermission.permissionFromDate)
      searchFilter.dateOfPermission = moment(
        filterPermission.permissionFromDate
      ).format("YYYY-MM-DD");
    if (filterPermission.permissionToDate)
      searchFilter.toDate = moment(filterPermission.permissionToDate).format(
        "YYYY-MM-DD"
      );
    if (filterPermission.employeeCode)
      searchFilter.employeeCode = filterPermission.employeeCode;
    if (!isEmpty(filterEmployee))
      searchFilter.employeeCode = filterEmployee?.value;
    if (!isEmpty(departments)) searchFilter.departmentId = departments.value;
    if (!isEmpty(approvalStatus))
      searchFilter.PermissionStatus = approvalStatus.value;
    try {
      const res = await api.post("/auth/getpermissionreq", searchFilter);
      const employees = res.data?.data || [];

      const mappedData = employees.map((data, index) => ({
        _id: data._id,
        sno: index + 1,
        employeeCode: data.employeeCode || "--",
        employeeName: data.employeeName || "--",
        date: data.dateOfPermission
          ? moment(data.dateOfPermission).format("DD/MM/YYYY")
          : "--",
        fromTime: data.fromHours || "--",
        toTime: data.toHours || "--",
        // duration: duration,
        department: data.departmentName || "--",
        departmentName: data.departmentName || "",
        departmentId: data.departmentId || "",
        designation: data.designationName || "--",
        designationName: data.designationName || "",
        reason: data.reason || "--",
        approvalStatus: data.PermissionStatus || "--",
        duration: data.duration || "--",
        approvedBy: data.approvedBy?.userName || "--",
        attachment: data.attachment || "--",
        appliedDate: data.createdOn
          ? moment(data.createdOn).format("DD/MM/YYYY")
          : "--",
        editData: data,
      }));

      // Only include fields for CSV that you want:
      const headers = [
        "S.No",
        "Department",
        "Designation",
        "Employee Code",
        "Employee Name",
        "Date",
        "Start Time",
        "End Time",
        "Duration",
        "Reason",
        "Approval Status",
        "Approved By",
        "Attachment",
        "Applied Date",
      ];

      const csvRows = mappedData.map((item) => [
        item.sno,
        item.department,
        item.designation,
        item.employeeCode,
        item.employeeName,
        item.date,
        item.fromTime,
        item.toTime,
        item.duration,
        item.reason,
        item.approvalStatus,
        item.approvedBy,
        item.attachment,
        item.appliedDate,
      ]);

      const csvContent = [
        headers.join(","),
        ...csvRows.map((row) => row.join(",")),
      ].join("\n");

      downloadFile({
        data: csvContent,
        fileName: "permisssion-details.csv",
        fileType: "text/csv",
      });
    } catch (error) {
      if (error) {
        setDownloadLoader(false);
      }
    } finally {
      setDownloadLoader(false);
    }
  };

  // search
  const handleSearch = () => {
    const payload = {
      search: searchInput,
      status: "BOTH",
    };
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    dispatch(permissionAction.loadPermission(payload));
  };

  //pofile picture on change and api functionality
  const handleSinglePhoto = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);
    setFileNames(fileArray[0].name);

    // Upload
    const uploadPromises = fileArray.map((file) => {
      const formData = new FormData();
      formData.append("profilePicture", file);
      return api
        .post("/auth/employee/upload-image", formData)
        .then((res) => {
          if (res?.status === 200 && res?.data?.file) {
            toast.success("Image uploaded successfully!", {
              containerId: "toast-1",
            });
            return {
              url: res.data.file,
              name: res.data.file,
            };
          } else {
            const errorMsg = res?.data?.error?.message || "Upload failed.";
            toast.error(errorMsg, { containerId: "toast-1" });
            return null;
          }
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.error?.message || "Upload error occurred.";
          toast.error(errorMsg, { containerId: "toast-1" });
          return null;
        });
    });

    const uploadedImages = await Promise.all(uploadPromises);
    const validUploads = uploadedImages.filter(Boolean);
    setImagePreviews(validUploads);
  };

  //image preview handler
  const handleRemoveImage = (urlToRemove) => {
    setImagePreviews([]);
    setFileNames("");
    URL.revokeObjectURL(urlToRemove);
  };

  const tableData =
    permissionList && !isEmpty(permissionList.data)
      ? permissionList.data.map((data, index) => {
          let duration = "--";
          if (data.fromHours && data.toHours) {
            const from = moment(data.fromHours.trim().replace(/\./g, ":"), [
              "h:mm a",
              "h a",
            ]);
            const to = moment(data.toHours.trim().replace(/\./g, ":"), [
              "h:mm a",
              "h a",
            ]);

            let durationInMinutes = to.diff(from, "minutes");

            const isNegative = durationInMinutes < 0;
            const absMinutes = Math.abs(durationInMinutes);
            const hours = Math.floor(absMinutes / 60);
            const minutes = absMinutes % 60;

            const prefix = isNegative ? "-" : "";
            const parts = [];

            if (hours > 0) parts.push(`${hours}h`);
            if (minutes > 0 || hours === 0) parts.push(`${minutes} mins`);

            duration = prefix + parts.join(" ");
          }
          return {
            _id: data._id,
            sno: index + 1,
            employeeCode: data.employeeCode || "--",
            employeeName: data.employeeName || "--",
            // date: data.dateOfPermission
            //   ? moment(data.dateOfPermission).format("DD/MM/YYYY")
            //   : "--",
            date: moment(data.dateOfPermission).format("DD/MM/YYYY") || "--",
            fromTime: data.fromHours
              ? moment(data.fromHours, "HH:mm").format("h.mm a")
              : "--",
            toTime: data.toHours
              ? moment(data.toHours, "HH:mm").format("h.mm a")
              : "--",
            duration: duration || "--",
            department: data.departmentName || "--",
            departmentName: data.departmentName || "",
            departmentId: data.departmentId || "",
            designation: data.designationName || "--",
            designationName: data.designationName || "",
            reason: data.reason || "--",
            approvalStatus: data.PermissionStatus || "--",
            // duration: data.duration || "--",
            approvedBy: data.approvedByUserName || "--",
            attachment: data.attachment ,
            // appliedDate: data.createdOn
            //   ? moment(data.createdOn).format("DD/MM/YYYY")
            //   : "--",
            appliedDate: moment(data.createdOn).format("DD/MM/YYYY") || "--",
            editData: data,
          };
        })
      : [];

  //table colums

  const columns = [
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          S.No
        </span>
      ),
      dataIndex: "sno",
      width: 70,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.sno - b.sno,
    },
    {
      title: <span className="poppins-txt">Action</span>,
      dataIndex: "action",
      width: 130,
      hidden: userType === "employee",
      render: (_, record) => (
        <Space style={{ gap: "8px" }}>
          {/* Edit Button */}
          <Button
            style={{
              background: "#34c38f",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            onClick={() => {
              handleEdit(record);
              setPermissionId(record._id);
            }}
          >
            <EditOutlined style={{ color: "#fff", fontSize: 14 }} />
          </Button>

          {/* Delete Button */}
          <Button
            style={{
              background: "#f46a6a",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            onClick={() => {
              setDeleteModalOpen(true);
              setPermissionId(record._id);
            }}
          >
            <DeleteOutlined style={{ color: "#fff", fontSize: 14 }} />
          </Button>

          {/* Approve Button */}
          <Button
            style={{
              background: "#f1b44c",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            type="primary"
            onClick={() => {
              setApprovalModalStatus([]);
              setRemarks("");
              setApproveModalOpen(true);
              setPermissionId(record._id);
            }}
          >
            <SafetyOutlined style={{ color: "#fff", fontSize: 18 }} />
          </Button>
        </Space>
      ),
    },
    {
      title: "Department",
      dataIndex: "department",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.department.localeCompare(b.department),
    },
    {
      title: "Designation",
      dataIndex: "designation",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.designation.localeCompare(b.designation),
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Employee Code
        </span>
      ),
      dataIndex: "employeeCode",
      width: 160,
      hidden: userType === "employee",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeCode.localeCompare(b.employeeCode),
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      hidden: userType === "employee",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeName.localeCompare(b.employeeName),
    },
    {
      title: "Date",
      dataIndex: "date",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.Date) - new Date(b.Date),
    },
    {
      title: "Start Time",
      dataIndex: "fromTime",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.fromTime) - new Date(b.fromTime),
    },
    {
      title: "End Time",
      dataIndex: "toTime",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.toTime) - new Date(b.toTime),
    },
    {
      title: "Duration",
      dataIndex: "duration",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.duration - b.duration,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.reason.localeCompare(b.reason),
    },
    {
      title: "Approval Status",
      dataIndex: "approvalStatus",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.approvalStatus.localeCompare(b.approvalStatus),
      render: (text, record) => {
        let color =
          text === "Pending"
            ? "#f46a6a"
            : text === "Approved"
            ? "#34c38f"
            : "#f46a6a";

        return (
          <div className="flex items-center justify-center">
            <div className="flex items-center w-full">
              <Badge
                count={text}
                style={{
                  backgroundColor: color,
                  color: "#fff",
                  padding: "0 8px",
                  height: "24px",
                  lineHeight: "24px",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </div>
            <div>
              <EyeOutlined
                style={{
                  fontSize: "16px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  color: "blue",
                }}
                onClick={() => {
                  setPermissionId(record._id);
                  setApprovalModalOpen(true);
                }}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Approved By",
      dataIndex: "approvedBy",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.approvedBy.localeCompare(b.approvedBy),
    },
    {
      title: "Attachment",
      dataIndex: "attachment",
      className: "poppins-txt-lg",
      render: (text, record) => {
        // const hasAttachment = !!record.attachment;
        return record.attachment!==null && record.attachment  ? (
          <a
            href={record.attachment}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            View
          </a>
        ) : (
          <span
            style={{
              color: "gray",
              textDecoration: "none",
              cursor: "not-allowed",
            }}
          >
            View
          </span>
        );
      },
    },
    {
      title: "Applied Date",
      dataIndex: "appliedDate",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.appliedDate) - new Date(b.appliedDate),
    },
  ];

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    setTimeout(() => {}, 1500);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // modal handling
  const showModalOpen = () => {
    setIsEdit(false);
    setIsModalVisible(true);
    simpleValidator.current.hideMessages();
    simpleValidator.current.hideMessageFor("password");
    forceUpdate(3);
    clearModelData();
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };
  // sl cl options conditions
  const loginUser = JSON.parse(localStorage.getItem("user"));
  const loggedInEmployeeId = loginUser?.employeeId;

  const matchedEmployee = dropDownList?.employeeOptions?.find(
    (emp) => emp._id === loggedInEmployeeId
  );
  // modal clear data
  const clearModelData = () => {
    setPermission({
      date: "",
      duration: "",
      fromTime: "",
      toTime: "",
      reason: "",
      employeeCode: "",
    });
    if (userType !== "admin") {
      const defaultLabel = `${matchedEmployee.label}`;
      setEmployeeCodeList(defaultLabel);
      setDepartment({
        label: matchedEmployee.departmentName || "",
        value: matchedEmployee.departmentId || "",
      });

      setDesignation({
        label: matchedEmployee.designationName || "",
        value: matchedEmployee.designationId || "",
      });
      setEmployeePayloadId(matchedEmployee._id);
    } else {
      setDepartment(null);
      setDesignation(null);
      setEmployeeCodeList();
    }
    // setEmployeeCodeClear(true);
    // setEmployeeCodeList([]);
    // setTimeout(() => {
    //   setEmployeeCodeClear(false);
    // }, 0);
    // setDepartment([]);
    // setDesignation([]);
    setFileNames([]);
    setImagePreviews([]);
  };

  //dropdown options

  const approvalStatusOptions = [
    { Typography: "Pending", value: "Pending" },
    { Typography: "Approved", value: "Approved" },
    { Typography: "Rejected", value: "Rejected" },
  ];

  const approvalOptions = [
    { Typography: "Approved", value: "Approved" },
    { Typography: "Rejected", value: "Rejected" },
  ];

  return (
    <React.Fragment>
      <div className="pl-5">
        <MetaTags>
          <title>Permission | Mequals</title>
        </MetaTags>
      </div>

      <Row justify="space-between" className="mr-4">
        <Col>
          <BreadcrumbComponent title="Permission" items={BCrumb} />
        </Col>

        <Col>
          <Button
            className="custom-btn mt-2"
            type="primary"
            size="medium"
            onClick={() => showModalOpen()}
          >
            {/* <span>{isEdit ? "Edit Leave" : "Apply Leave"}</span> */}
            Apply Permission
          </Button>
        </Col>
      </Row>

      <Modal
        open={isModalVisible}
        onCancel={handleModalClose}
        title="Apply Permission"
        className="poppins-txt custom-active-modal"
        centered
        maskClosable={false}
        footer={null}
        width="70vw"
        maxWidth="1200px"
        style={{
          padding: 0,
          marginLeft: windowDimensions.width > 992 ? "220px" : "0",
        }}
      >
        <div className="custom-modal-content">
          <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Employee Code
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>

              <ReactSearchAutocomplete
                name="employeeCodeList"
                inputSearchString={employeeCodeList}
                key={employeeCodeClear}
                items={
                  showDropdown && dropDownList.employeeOptions
                    ? dropDownList.employeeOptions
                    : []
                }
                value={employeeCodeList}
                type="autoComplete"
                resultStringKeyName="label"
                showIcon={false}
                onChange={(e) => {
                  if (userType !== "employee")
                    setEmployeeCodeList(e.target.value);
                }}
                onFocus={() => {
                  if (userType !== "employee") setShowDropdown(true);
                }}
                onSelect={(item) => {
                  if (userType !== "employee") {
                    setEmployeeCodeList(item.label);
                    setEmployeePayloadId(item._id);
                    setShowDropdown(false);
                    handleEmployeeSelect(item);
                  }
                }}
                onSearch={(string, results) => {
                  if (userType !== "employee") setShowDropdown(true);
                }}
                onClear={() => {
                  if (userType !== "employee") handleEmployeeCodeClear();
                }}
                showClear={userType !== "employee"}
                placeholder="Enter Employee code"
                fuseOptions={fuseOptions}
                className="text-end hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mb-[-6px]"
                styling={{
                  height: "30px",
                  border: "1px solid #ced4da",
                  borderRadius: "4px",
                  backgroundColor:
                    userType === "employee" ? "#f5f5f5" : "white",
                  pointerEvents: userType === "employee" ? "none" : "auto",
                  opacity: userType === "employee" ? 0.6 : 1,
                  boxShadow: "none",
                  textAlign: "end",
                  hoverBackgroundColor: "lightgray",
                  color: "black",
                  fontSize: "12px",
                  fontFamily: "Poppins",
                  iconColor: "green",
                  clearIconMargin: "3px 8px 0 0",
                  zIndex: 10,
                }}
              />

              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "employeeCode",
                  employeeCodeList,
                  "required"
                )}
              </span>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Department
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>
              <Select
                placeholder="Select department"
                allowClear
                className="custom-select"
                name="department"
                value={department}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setDepartment({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setDepartment({ label: "", value: "" });
                  }
                }}
                disabled
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "department",
                  department,
                  "required"
                )}
              </span>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Designation
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>
              <Select
                placeholder="Select designation"
                allowClear
                className="custom-select"
                name="designation"
                value={designation}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setDesignation({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setDesignation({ label: "", value: "" });
                  }
                }}
                disabled
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "designation",
                  designation,
                  "required"
                )}
              </span>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Date
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>
              <DatePicker
                className="custom-select w-100"
                value={permission.date}
                onChange={(date) => handleDateChange("date", date)}
                minDate={dayjs().add(1, "day")}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "date",
                  permission.date,
                  "required"
                )}
              </span>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  From Time
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>

              <TimePicker
                showSecond={false}
                minuteStep={15}
                value={permission.fromTime}
                onChange={(time) => handleTimeChange("fromTime", time)}
                use12Hours={false}
                format="HH:mm"
                inputReadOnly
                disabled={isTimeInputDisabled}
                style={{ width: "100%" }}
                className="custom-select-time w-100"
                placeholder="Select from time"
                popupClassName={
                  isTimeInputDisabled ? "tooltip-time-disabled" : ""
                }
              />
              {isTimeInputDisabled && (
                <div
                  style={{
                    color: "#ef3022",
                    fontSize: "11px",
                    fontFamily: "poppins",
                    marginTop: "5px",
                  }}
                >
                  Before 9 AM only you can apply permission.
                </div>
              )}

              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "fromTime",
                  permission.fromTime,
                  "required"
                )}
              </span>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  To Time
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>

              <TimePicker
                showSecond={false}
                minuteStep={15}
                value={permission.toTime}
                onChange={(time) => handleTimeChange("toTime", time)}
                use12Hours={false}
                format="HH:mm"
                inputReadOnly
                disabled={isTimeInputDisabled}
                style={{ width: "100%" }}
                className="custom-select-time w-100"
                placeholder="Select to time"
                disabledHours={() => {
                  if (!permission.fromTime) return [];
                  const from = moment(permission.fromTime);
                  const max = moment(from).add(3, "hours");

                  const disabled = [];
                  for (let h = 0; h < 24; h++) {
                    if (h < from.hour() || h > max.hour()) {
                      disabled.push(h);
                    }
                  }

                  return disabled;
                }}
                disabledMinutes={(selectedHour) => {
                  if (!permission.fromTime) return [];
                  const from = moment(permission.fromTime);
                  const max = moment(from).add(3, "hours");

                  const allowedMinutes = [0, 15, 30, 45];
                  const disabled = [];

                  for (let m of allowedMinutes) {
                    const selected = moment({ hour: selectedHour, minute: m });

                    // If selected time is before fromTime or after max, disable it
                    if (selected.isBefore(from) || selected.isAfter(max)) {
                      disabled.push(m);
                    }
                  }

                  return disabled;
                }}
              />
              {isTimeInputDisabled && (
                <div
                  style={{
                    color: "#ef3022",
                    fontSize: "11px",
                    fontFamily: "poppins",
                    marginTop: "5px",
                  }}
                >
                  Before 9 AM only you can apply permission.
                </div>
              )}
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "toTime",
                  permission.toTime,
                  "required"
                )}
              </span>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">Duration</Typography>
              </div>
              <Input
                type="text"
                value={permission.duration}
                className="custom-select py-2"
                readOnly
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="mb-2">
                <Typography className="poppins-txt">Reason</Typography>
              </div>
              <TextArea
                placeholder="Enter Reason"
                rows={3}
                name="reason"
                value={permission.reason}
                onChange={(e) => handleChange(e)}
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <Typography className="poppins-txt">Attachment File</Typography>
              <div style={{ position: "relative", marginTop: 8 }}>
                <Input
                  value={fileNames}
                  accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain"
                  placeholder="Choose File"
                  readOnly
                  // Clicking the input triggers the hidden file input click
                  onClick={() =>
                    document.getElementById("gallery-file-upload").click()
                  }
                  // Prefix with a filled cloud upload icon, styled larger with margin (gap)
                  prefix={
                    <CloudUploadOutlined
                      style={{
                        color: "blue",
                        fontSize: 24,
                        marginRight: 12, // Increase the gap between icon and placeholder
                      }}
                    />
                  }
                  style={{
                    cursor: "pointer",
                    paddingLeft: 8, // Adds a little more padding on the left for the text
                  }}
                />

                {/* Hidden file input overlay */}
                <input
                  id="gallery-file-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleSinglePhoto} // <- change handler name too
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                  }}
                />
              </div>

              {/* Image previews */}
              {imagePreviews.length > 0 && (
                <div style={{ marginTop: 16 }}>
                  {imagePreviews.map((img, imgsIndex) => (
                    <div
                      key={imgsIndex}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Typography
                        style={{
                          textDecoration: "underline",
                          color: "blue",
                          "&:hover": { color: "darkblue" },
                          fontSize: "14px",
                        }}
                        onClick={() => window.open(img.url, "_blank")}
                      >
                        View
                      </Typography>

                      <CloseOutlined
                        onClick={() => handleRemoveImage(imgsIndex)}
                        style={{
                          fontSize: 16,
                          color: "#ef3022",
                          padding: "2px",
                          marginLeft: "2px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </Col>
          </Row>
        </div>

        {/* Custom footer with cancel and confirm buttons */}
        <div
          className="custom-modal-footer"
          style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="custom-btn"
            onClick={handleModalClose}
            style={{
              backgroundColor: "#f46a6a",
              color: "#fff",
              border: "none",
              marginRight: "10px",
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={disabled || isTimeInputDisabled}
            className="custom-btn"
            style={{
              backgroundColor: "#34c38f",
              color: "#fff",
              border: "none",
            }}
            onClick={handleInitialSubmit}
          >
            {isEdit ? "Update" : "Submit"}
          </Button>
        </div>
        <ToastContainer
          containerId="toast-1"
          position="top-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          style={{
            fontSize: "12px",
          }}
          pauseOnHover
          theme="dark"
        />
      </Modal>

      <Modal
        open={isConfirmVisible}
        onCancel={() => setIsConfirmVisible(false)}
        title={"Confirmation"}
        // title="Apply Leave"
        className="poppins-txt custom-active-modal"
        centered
        maskClosable={false}
        width={450}
        footer={null}
        maxWidth="1200px"
        style={{
          padding: 0,
          marginLeft: windowDimensions.width > 992 ? "220px" : "0",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <p className="poppins-txt" style={{ padding: "15px" }}>
            Are you sure Do you want to {isEdit ? "update" : "submit"} this
            request?
          </p>

          <div
            className="custom-modal-footer"
            style={{
              borderTop: "1px solid #ccc",
              padding: "10px 16px 0px 0px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="custom-btn"
              style={{
                backgroundColor: "#f46a6a",
                color: "#fff",
                border: "none",
                marginRight: "10px",
              }}
              onClick={() => setIsConfirmVisible(false)}
            >
              Close
            </Button>
            <Button
              disabled={disabled}
              className="custom-btn"
              onClick={() => {
                handleSubmit();
                setIsConfirmVisible(false);
              }}
              style={{
                backgroundColor: "#34c38f",
                color: "#fff",
                border: "none",
              }}
            >
              Confirm
            </Button>
          </div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          ></div>
        </div>
      </Modal>

      <Modal
        title={"Confirmation"}
        open={deleteModalOpen}
        onCancel={handleDeleteModalCancel}
        cancelText="Cancel"
        className="poppins-txt custom-active-modal"
        width={450}
        footer={null}
        // style={{ padding: 0 }}
        centered
      >
        <div className="custom-modal-content">
          <p>Are you sure you want to delete this leave details?</p>
        </div>

        <div
          className="custom-modal-footer"
          style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="custom-btn"
            style={{
              backgroundColor: "#f46a6a",
              color: "#fff",
              border: "none",
              marginRight: "10px",
            }}
            onClick={() => handleDeleteModalCancel()}
          >
            Close
          </Button>
          <Button
            disabled={disabled}
            className="custom-btn"
            onClick={() => handleDelete()}
            style={{
              backgroundColor: "#34c38f",
              color: "#fff",
              border: "none",
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>

      <Modal
        title={"Confirmation"}
        open={approveModalOpen}
        onCancel={handleApproveModalCancel}
        cancelText="Cancel"
        className="poppins-txt custom-active-modal"
        width={450}
        footer={null}
        // style={{ padding: 0 }}
        centered
      >
        <div className="custom-modal-content">
          {/* <p>Are you sure you want to approve this leave details?</p> */}
          <Col xs={24}>
            <div className="mb-2">
              <Typography className="poppins-txt">
                Approval Status
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
            </div>
            <Select
              placeholder="Select approval status"
              allowClear
              className="custom-select"
              name="approvalModalStatus"
              value={approvalModalStatus}
              onChange={(value, options) => {
                if (options) {
                  // normal selection
                  setApprovalModalStatus({
                    label: options.label,
                    value: value,
                  });
                } else {
                  // cleared selection
                  setApprovalModalStatus({ label: "", value: "" });
                }
              }}
              options={approvalOptions}
              autoComplete="off"
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
            />
            <span
              style={{
                color: "#ef3022",
                fontSize: "11px",
                marginTop: "8px",
                fontFamily: "poppins",
                display: "block",
              }}
            >
              {simpleApproveValidator.current.message(
                "approvalModalStatus",
                approvalModalStatus,
                "required"
              )}
            </span>
          </Col>
          <Col xs={24} style={{ marginTop: "5px" }}>
            <div className="mb-2">
              <Typography className="poppins-txt">Remarks</Typography>
            </div>
            <TextArea
              placeholder="Enter Remarks"
              rows={3}
              name="remarks"
              value={remarks}
              onChange={(e) => handleApprovalChange(e)}
            />
          </Col>
        </div>

        <div
          className="custom-modal-footer"
          style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="custom-btn"
            style={{
              backgroundColor: "#f46a6a",
              color: "#fff",
              border: "none",
              marginRight: "10px",
            }}
            onClick={() => handleApproveModalCancel()}
          >
            Close
          </Button>
          <Button
            disabled={disabled}
            className="custom-btn"
            onClick={() => handleApproveUpdate()}
            style={{
              backgroundColor: "#34c38f",
              color: "#fff",
              border: "none",
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>

      <Modal
        title={"Approval Status"}
        open={approvalModalOpen}
        onCancel={() => setApprovalModalOpen(false)}
        cancelText="Cancel"
        className="poppins-txt custom-active-modal"
        footer={null}
        maskClosable={false}
        // style={{ top: 90, left: 100 }}
        width={
          windowDimensions.width > 992
            ? 700
            : windowDimensions.width > 600
            ? 600
            : windowDimensions.width - 40
        }
        style={{
          top: 90,
          padding: 0,
          ...(windowDimensions.width > 1189
            ? { marginLeft: "400px" }
            : windowDimensions.width > 992
            ? { marginLeft: "300px" }
            : windowDimensions.width > 600
            ? { margin: "0 auto" }
            : windowDimensions.width > 40
            ? { margin: "0 auto" }
            : { marginLeft: "0" }),
        }}
        // style={{ padding: 0 }}
      >
        <div className="custom-modal-content">
          <Table
            columns={columnApproval}
            dataSource={tableApprovalData}
            className="poppins-txt mb-2"
            rowKey={(record) => record._id}
            rowClassName={"text-[12px]"}
            size="small"
            pagination={false}
          />
        </div>

        <div
          className="custom-modal-footer"
          style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="custom-btn"
            style={{
              backgroundColor: "#f46a6a",
              color: "#fff",
              border: "none",
              marginRight: "10px",
            }}
            onClick={() => setApprovalModalOpen(false)}
          >
            Close
          </Button>
        </div>
      </Modal>
      <div
        style={{
          background: "#ffffff",
          margin: "4px 8px 4px 8px", // top, right, bottom, left
          padding: "16px",
          borderRadius: "8px 8px 0px 0px",
        }}
      >
        <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
          {userType === "admin" && (
            <>
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">Employee Code</Typography>
                </div>
                <ReactSearchAutocomplete
                  name="filterEmployee"
                  key={filterEmployeeClear}
                  items={
                    dropDownList.employeeOptions
                      ? dropDownList.employeeOptions
                      : []
                  }
                  value={filterEmployee}
                  type="autoComplete"
                  resultStringKeyName="label"
                  onFocus={() => setShowDropdown(true)}
                  showIcon={false}
                  onChange={(e) => {
                    setFilterEmployee(e.target.value);
                  }}
                  onSelect={(item) => {
                    setFilterEmployee(item);
                  }}
                  //   onSelect={handleEmployeeSelect}
                  onClear={() => setFilterEmployee([])}
                  showClear
                  placeholder="Enter Employee code"
                  fuseOptions={fuseOptions} // Search on both fields
                  className="text-end hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mb-[-6px]"
                  styling={{
                    height: "30px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    backgroundColor: "white",
                    boxShadow: "none",
                    textAlign: "end",
                    hoverBackgroundColor: "lightgray",
                    color: "black",
                    // marginBottom: "-3px",
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    iconColor: "green",
                    clearIconMargin: "3px 8px 0 0",
                    zIndex: 10,
                  }}
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">Department</Typography>
                </div>
                <Select
                  placeholder="Select department"
                  allowClear
                  className="custom-select"
                  name="departments"
                  value={departments}
                  onChange={(value, options) => {
                    if (options) {
                      // normal selection
                      setDepartments({
                        label: options.label,
                        value: value,
                      });
                    } else {
                      // cleared selection
                      setDepartments({ label: "", value: "" });
                    }
                  }}
                  options={
                    !isEmpty(dropDownList) ? dropDownList.departmentOptions : []
                  }
                  autoComplete="off"
                  dropdownRender={(menu) => (
                    <h1 className="option-text-font">{menu}</h1>
                  )}
                />
              </Col>
            </>
          )}

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Permission From Date
                </Typography>
              </div>
              <DatePicker
                className="custom-select py-2"
                name="permissionFromDate"
                value={filterPermission.permissionFromDate}
                onChange={(date) =>
                  handleFilterDateChange("permissionFromDate", date)
                }
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Permission To Date
                </Typography>
              </div>
              <DatePicker
                className="custom-select py-2"
                name="permissionToDate"
                value={filterPermission.permissionToDate}
                onChange={(date) =>
                  handleFilterDateChange("permissionToDate", date)
                }
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">Approval Status</Typography>
            </div>
            <Select
              placeholder="Select approval status"
              allowClear
              className="custom-select"
              name="approvalStatus"
              value={approvalStatus}
              onChange={(value, options) => {
                if (options) {
                  // normal selection
                  setApprovalStatus({
                    label: options.label,
                    value: value,
                  });
                } else {
                  // cleared selection
                  setApprovalStatus({ label: "", value: "" });
                }
              }}
              options={approvalStatusOptions}
              autoComplete="off"
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
            />
          </Col>
        </Row>

        <Row justify="end" style={{ marginTop: "8px" }}>
          <Col>
            <Button
              className="custom-btn"
              icon={<ReloadOutlined style={{ fontSize: "16px" }} />}
              size="middle"
              onClick={onReset}
              loading={resetLoading}
              danger
              style={{ marginRight: "12px" }}
            >
              Reset
            </Button>
            <Button
              className="custom-btn"
              type="primary"
              size="middle"
              icon={<FilterOutlined style={{ fontSize: "18px" }} />}
              htmlType="submit"
              onClick={handleFilter}
              loading={searchLoading}
            >
              Apply Filter
            </Button>
          </Col>
        </Row>
      </div>

      <div
        style={{
          background: "#ffffff",
          margin: "20px 8px 15px 8px", // top, right, bottom, left
          padding: "16px",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col>
            {userType === "admin" ? (
              <>
                <Input
                  placeholder="Search..."
                  allowClear
                  style={{ width: 250, fontFamily: "Poppins" }}
                  name="searchInput"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  type="text"
                  autoComplete="off"
                />
                <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  style={{ marginLeft: 8 }}
                  onClick={handleSearch}
                />
              </>
            ) : (
              // Empty div to maintain spacing
              <div style={{ width: 250 }}></div>
            )}
          </Col>

          <Col>
            <Button
              className="custom-btn"
              size="medium"
              type="primary"
              icon={<DownloadOutlined />}
              loading={downloadLoader}
              onClick={exportToCsv}
            >
              Download
            </Button>
          </Col>
        </Row>

        <Table
          columns={columns}
          loading={searchLoading}
          // dataSource={filteredData.length ? filteredData : sampleData}
          dataSource={filterPermission.length ? filterPermission : tableData}
          className="poppins-txt"
          rowKey={(record) => record._id}
          rowClassName={"text-[12px]"}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalCount, // make sure you provide total count from API
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "30"],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          }}
          sortDirections={["ascend", "descend"]}
          showSorterTooltip={"sorter-icon"}
          scroll={{
            x: 765,
          }}
          onChange={(pagination, filters, sorter) => {
            const { current, pageSize } = pagination;
            setCurrentPage(current); // you can manage currentPage and pageSize in your component state if needed
            setPageSize(pageSize);
            const updatedParams = {
              ...searchValue,
              page: current,
              limit: pageSize,
              status: "BOTH",
            };

            setSearchValue(updatedParams);
            specificDispatch(permissionAction.loadPermission(updatedParams));
          }}
        />
      </div>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};
//Permission
export default Permission;
